import type { Ref } from 'vue'

type RedirectValue = string | (string | null)[] | null | undefined

function getRedirectString(value: RedirectValue): string | null {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0] : null
  }

  return typeof value === 'string' ? value : null
}

export function getSafeAuthRedirectPath(value: RedirectValue): string | null {
  const redirectPath = getRedirectString(value)?.trim()

  if (!redirectPath || !redirectPath.startsWith('/') || redirectPath.startsWith('//')) {
    return null
  }

  try {
    const normalizedUrl = new URL(redirectPath, 'http://localhost')
    return `${normalizedUrl.pathname}${normalizedUrl.search}${normalizedUrl.hash}`
  } catch {
    return null
  }
}

export function consumeAuthRedirectPath(
  routeRedirect: RedirectValue,
  redirectCookie: Ref<string | undefined>,
  fallbackPath = '/purchase'
): string {
  const nextPath = getSafeAuthRedirectPath(routeRedirect) ?? getSafeAuthRedirectPath(redirectCookie.value) ?? fallbackPath

  redirectCookie.value = undefined

  return nextPath
}
